import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import { useSelector } from 'react-redux';
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }: any) {
  // const { isAuthenticated } = useAuth();
  const user = useSelector((state: any) => state.user);

  if (user) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
